import restaurantPrinterApi from '../../api/restaurant/restaurantPrinterApi';
import {
  CustomResponse,
  RestaurantPrinterDTO,
  RestaurantPrinterFilters,
  RestaurantPrinterForm,
  RestaurantPrinterPage,
} from '../../types/restaurant/RestaurantPrinterTypes';
import { appendRestaurantQuery } from './restaurantPageQuery';

const payload = (form: RestaurantPrinterForm) => ({
  name: form.name.trim(),
  description: form.description.trim() || null,
  printerName: form.printerName.trim(),
  printerType: form.printerType,
  connectionType: form.connectionType,
  ipAddress:
    form.connectionType === 'NETWORK' ? form.ipAddress.trim() : null,
  port: form.connectionType === 'NETWORK' ? Number(form.port) : null,
  displayOrder: Number(form.displayOrder),
  enabled: form.enabled,
  ...(form.id ? { active: form.active } : {}),
});

const RestaurantPrinterService = {
  list: async (branchId: number, filters: RestaurantPrinterFilters) => {
    const query = appendRestaurantQuery(
      new URLSearchParams({ page: String(filters.page), size: String(filters.size) }),
      {
        search: filters.search?.trim(),
        printerType: filters.printerType,
        connectionType: filters.connectionType,
        active: filters.active,
        enabled: filters.enabled,
      }
    );
    const response = await restaurantPrinterApi.fetchCustom(
      `/branches/${branchId}/printers?${query}`
    );
    return response.data as RestaurantPrinterPage;
  },

  get: async (id: number) => {
    const response = await restaurantPrinterApi.fetchCustom(`/printers/${id}`);
    return response.data as CustomResponse<RestaurantPrinterDTO>;
  },

  create: async (branchId: number, form: RestaurantPrinterForm) => {
    const response = await restaurantPrinterApi.addCustom(
      `/branches/${branchId}/printers`,
      payload(form)
    );
    return response.data as CustomResponse<RestaurantPrinterDTO>;
  },

  update: async (id: number, form: RestaurantPrinterForm) => {
    const response = await restaurantPrinterApi.modifyCustom(
      `/printers/${id}`,
      payload(form)
    );
    return response.data as CustomResponse<RestaurantPrinterDTO>;
  },

  deactivate: async (id: number) => {
    const response = await restaurantPrinterApi.removeCustom(`/printers/${id}`);
    return response.data as CustomResponse<null>;
  },
};

export default RestaurantPrinterService;
